<app-appointment-patient-login
  *ngIf="!patientAppointment.requested"
  [dir]="'ar'"
  [patientAppointment]="patientAppointment">
</app-appointment-patient-login>

<!-- ======================= FR ======================= -->
<ng-container *ngIf="patientAppointment.requested && dir=='fr'">
  <form [formGroup]="appointmentRequestForm">
    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>Prénom</label>
          <form-input
            [placeholder]="'Prénom'"
            [append]="'fi feather-user'"
            [required]="true"
            name="firstName"
            formControlName="firstName"
         [ngClass]="{
        'is-invalid': (f.firstName.touched || isSubmited) &&
                      (f.firstName.errors?.required || f.firstName.errors?.['alphabetInvalid'])
      }">
          </form-input>

         <span *ngIf="(f.firstName.touched || isSubmited) && f.firstName.errors?.required" class="invalid-input">
      Prénom est obligatoire
    </span>

    <span *ngIf="(f.firstName.touched || isSubmited) && f.firstName.errors?.['alphabetInvalid']" class="invalid-input">
      Prénom invalid format - doit contenir uniquement des lettres
    </span>

        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
  <div class="form-group">
    <label>Nom</label>

    <form-input
      [placeholder]="'Nom'"
      [append]="'fi feather-user'"
      [required]="true"
      name="lastName"
      formControlName="lastName"
      [ngClass]="{
        'is-invalid': (f.lastName.touched || isSubmited) &&
                      (f.lastName.errors?.required || f.lastName.errors?.['alphabetInvalid'])
      }">
    </form-input>

    <span *ngIf="(f.lastName.touched || isSubmited) && f.lastName.errors?.required" class="invalid-input">
      Nom est obligatoire
    </span>

    <span *ngIf="(f.lastName.touched || isSubmited) && f.lastName.errors?.['alphabetInvalid']" class="invalid-input">
      Nom invalid format - doit contenir uniquement des lettres
    </span>
  </div>
</div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>Pays</label>
          <select-drop-down
            [items]="countries"
            (ngModelChange)="onCountryChanged($event)"
            [options]="{ filter:{ byKey:'name' } }"
            [value]="defaultCountry"
            formControlName="country"
            name="country">

        <ng-template let-item="item">
  <div class="country-item" >
    <img
      class="country-flag"
      [src]="item.flagUrl || item.flag"
      [alt]="item.name"
    />
    <span class="country-name">{{ item.name }}</span>
  </div>
</ng-template>
          </select-drop-down>

          <span *ngIf="isSubmited && f.country.errors?.required" class="invalid-input">
            Pays est obligatoire
          </span>
        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>Téléphone</label>
          <form-input
            [placeholder]="'Téléphone'"
            [prependHtml]="dialCode"
            [append]="'fi feather-phone'"
            name="mobilePhone"
            formControlName="mobilePhone"
             [ngClass]="{
      'is-invalid': f.mobilePhone.touched && f.mobilePhone.invalid
    }"
            >
          </form-input>

          <span *ngIf="f.mobilePhone.touched && f.mobilePhone.errors?.required" class="invalid-input">
            Téléphone est obligatoire pour la Tunisie
          </span>

          <span *ngIf="f.mobilePhone.touched && f.mobilePhone.errors?.pattern" class="invalid-input">
            Numéro de téléphone invalide - doit contenir 8 chiffres pour la Tunisie
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>Date de naissance</label>
          <date-picker
            [append]="'fi feather-calendar'"
            name="birthDate"
            formControlName="birthDate">
          </date-picker>

          <span *ngIf="isSubmited && f.birthDate.errors?.required" class="invalid-input">
            Date de naissance est obligatoire
          </span>
        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
  <label>Email</label>

  <form-input
    [placeholder]="'E-mail'"
    [append]="'fi feather-mail'"
    name="email"
    formControlName="email"
    [ngClass]="{
      'is-invalid': f.email.touched && f.email.invalid
    }">
  </form-input>

  <span *ngIf="f.email.touched && f.email.errors?.required" class="invalid-input">
    Email est obligatoire pour les patients hors Tunisie
  </span>

  <span *ngIf="f.email.touched && f.email.errors?.email" class="invalid-input">
    Format email invalide
  </span>
</div>
      </div>
    </div>
  </form>
</ng-container>

<!-- ======================= AR ======================= -->
<ng-container *ngIf="patientAppointment.requested && dir=='ar'">
  <form [formGroup]="appointmentRequestForm">
    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>اللقب</label>
          <form-input
            [placeholder]="'اللقب'"
            [append]="'fi feather-user'"
            [required]="true"
            name="firstName"
            formControlName="firstName"
            [ngClass]="{
              'is-invalid': (f.firstName.touched || isSubmited) &&
                            (f.firstName.errors?.required || f.firstName.errors?.['alphabetInvalid'])
            }">
          </form-input>

          <span *ngIf="(f.firstName.touched || isSubmited) && f.firstName.errors?.required" class="invalid-input">
            اللقب مطلوب
          </span>
          <span *ngIf="(f.firstName.touched || isSubmited) && f.firstName.errors?.['alphabetInvalid']" class="invalid-input">
            اللقب يجب أن يحتوي فقط على أحرف
          </span>
        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>الاسم</label>
          <form-input
            [placeholder]="'الاسم'"
            [append]="'fi feather-user'"
            [required]="true"
            name="lastName"
            formControlName="lastName"
            [ngClass]="{
              'is-invalid': (f.lastName.touched || isSubmited) &&
                            (f.lastName.errors?.required || f.lastName.errors?.['alphabetInvalid'])
            }">
          </form-input>

          <span *ngIf="(f.lastName.touched || isSubmited) && f.lastName.errors?.required" class="invalid-input">
            الإسم مطلوب
          </span>
          <span *ngIf="(f.lastName.touched || isSubmited) && f.lastName.errors?.['alphabetInvalid']" class="invalid-input">
            الإسم يجب أن يحتوي فقط على أحرف
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>الدولة</label>
          <select-drop-down
            [items]="countries"
            (ngModelChange)="onCountryChanged($event)"
            [options]="{ filter:{ byKey:'name' } }"
            [value]="defaultCountry"
            formControlName="country"
            name="country">

         <ng-template let-item="item">
  <div class="country-item" >
    <img
      class="country-flag"
      [src]="item.flagUrl || item.flag"
      [alt]="item.name"
    />
    <span class="country-name">{{ item.name }}</span>
  </div>
</ng-template>
          </select-drop-down>

          <span *ngIf="isSubmited && f.country.errors?.required" class="invalid-input">
            البلد مطلوب
          </span>
        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>الهاتف</label>
          <form-input
            [placeholder]="'الهاتف'"
            [prependHtml]="dialCode"
            [append]="'fi feather-phone'"
            name="mobilePhone"
            formControlName="mobilePhone"
             [ngClass]="{
      'is-invalid': f.mobilePhone.touched && f.mobilePhone.invalid
    }"
            >
          </form-input>

          <span *ngIf="f.mobilePhone.touched && f.mobilePhone.errors?.required" class="invalid-input">
            الهاتف مطلوب للمرضى من تونس
          </span>

          <span *ngIf="f.mobilePhone.touched && f.mobilePhone.errors?.pattern" class="invalid-input">
            رقم الهاتف غير صالح - يجب أن يحتوي على 8 أرقام للتوثيق
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group">
          <label>تاريخ الولادة</label>
          <date-picker
            [append]="'fi feather-calendar'"
            name="birthDate"
            formControlName="birthDate">
          </date-picker>

          <span *ngIf="isSubmited && f.birthDate.errors?.required" class="invalid-input">
            تاريخ الميلاد مطلوب
          </span>
        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
   <div class="form-group">
  <label>البريد الإلكتروني</label>

  <form-input
    [placeholder]="'بريد إلكتروني'"
    [append]="'fi feather-mail'"
    name="email"
    formControlName="email"
    [ngClass]="{
      'is-invalid': f.email.touched && f.email.invalid
    }">
  </form-input>

  <span *ngIf="f.email.touched && f.email.errors?.required" class="invalid-input">
    البريد الإلكتروني مطلوب للمرضى من خارج تونس
  </span>

  <span *ngIf="f.email.touched && f.email.errors?.email" class="invalid-input">
    صيغة البريد الإلكتروني غير صحيحة
  </span>
</div>
      </div>
    </div>
  </form>
</ng-container>

<!-- ======================= LINKS ======================= -->
<a
  *ngIf="!patientAppointment.requested && dir=='ar'"
  class="btn small btm"
  (click)="patientAppointment.requested = true;"
  style="text-decoration: underline;">
  لا أملك حساب؟
</a>

<a
  *ngIf="patientAppointment.requested && dir=='ar'"
  class="btn small btm"
  (click)="patientAppointment.requested = false;"
  style="text-decoration: underline;">
  لدي حساب SilaDoc؟
</a>

<a
  *ngIf="!patientAppointment.requested && dir=='fr'"
  class="btn small btm"
  (click)="patientAppointment.requested = true;"
  style="text-decoration: underline;">
  Je n'ai pas de compte ?
</a>

<a
  *ngIf="patientAppointment.requested && dir=='fr'"
  class="btn small btm text-center"
  (click)="patientAppointment.requested = false;"
  style="text-decoration: underline;">
  J'ai un compte SilaDoc ?
</a>